import React from 'react';
import Modal from 'components/shared/modals/Modal';
import Picker from 'react-mobile-picker';
import styles from './TimePicker.module.scss';
import Button from 'components/shared/Button/Button';
import { useTranslation } from 'react-i18next';

type TimePickerModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (time: string) => void;
}

const TimePickerModal: React.FC<TimePickerModalProps> = ({ isOpen, onClose, onSelect }) => {

  const t = useTranslation() as any;

  const [selectedValue, setSelectedValue] = React.useState({
    hours: '12',
    minutes: '00',
    period: 'PM'
  });

  const pickerData = {
    hours: Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, '0')),
    minutes: Array.from({ length: 60 }, (_, i) => String(i).padStart(2, '0')),
    period: ['AM', 'PM']
  };

  const handleSelect = () => {
    const timeString = `${selectedValue.hours}:${selectedValue.minutes} ${selectedValue.period}`;
    onSelect(timeString);
    onClose();
  };

  return (
    <Modal
      bottom
      circleCloseBtn
      isOpen={isOpen}
      onClose={onClose}
      className={styles.timePickerModal}
      onClick={(e) => e.stopPropagation()}
    >
      <div className={styles.modalContent}>
        <div className={styles.header}>Choose time</div>
        <Picker
          value={selectedValue}
          onChange={setSelectedValue}
          height={160}
          itemHeight={40}
          wheelMode="natural"
        >
          <Picker.Column name="hours">
            {pickerData.hours.map(hour => (
              <Picker.Item key={hour} value={hour}>
                {hour}
              </Picker.Item>
            ))}
          </Picker.Column>
          <Picker.Column name="minutes">
            {pickerData.minutes.map(minute => (
              <Picker.Item key={minute} value={minute}>
                {minute}
              </Picker.Item>
            ))}
          </Picker.Column>
          <Picker.Column name="period">
            {pickerData.period.map(period => (
              <Picker.Item key={period} value={period}>
                {period}
              </Picker.Item>
            ))}
          </Picker.Column>
        </Picker>
        <Button className={styles.footer} onClick={handleSelect} wide darkGreen>
          Apply
        </Button>
      </div>
    </Modal>
  );
};

export default TimePickerModal;